/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IDobbiesFlipbookData } from './dobbies-flipbook.data';
import { IDobbiesFlipbookProps } from './dobbies-flipbook.props.autogenerated';

export interface IDobbiesFlipbookViewProps extends IDobbiesFlipbookProps<IDobbiesFlipbookData> {}

/**
 *
 * DobbiesFlipbook component
 * @extends {React.PureComponent<IDobbiesFlipbookProps<IDobbiesFlipbookData>>}
 */
class DobbiesFlipbook extends React.PureComponent<IDobbiesFlipbookProps<IDobbiesFlipbookData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default DobbiesFlipbook;
